import { Component, Input, OnChanges, SimpleChanges, Optional } from '@angular/core';
import { ToastPackage } from 'ngx-toastr';
import { NgIf, NgClass } from '@angular/common';

export interface Banner {
	type: 'success' | 'error' | 'warning' | 'info';
	title?: string;
	description?: string;
}

@Component({
	selector: 'app-banner',
	templateUrl: './banner.component.html',
	styleUrls: ['./banner.component.scss'],
	imports: [NgIf, NgClass],
})
export class BannerComponent implements OnChanges {
	@Input()
	public open: boolean = true;

	@Input()
	public data: Banner | null = null;

	@Input()
	public showClose: boolean = true;

	constructor(@Optional() toastPackage: ToastPackage) {
		if (toastPackage) {
			this.data = {
				type: toastPackage.config.toastClass as 'success' | 'error' | 'warning' | 'info',
				title: toastPackage.title,
				description: toastPackage.message || '',
			};
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['data']) {
			this.open = true;
		}
	}

	getIcon(): string {
		return `assets/banner-${this.data?.type}.svg`;
	}

	close(): void {
		this.open = false;
	}
}
